export class ImageProperty {
  file: any;
  fileName: string;
  src: string;
  width: string;
  height: string;
}
